import { PiStairsFill } from "react-icons/pi";

export const links = [
  {
    name: "Welcome",
    path: "/",
  },
  // {
  //   name: "Home",
  //   path: "/",
  // },
  // {
  //   name: "Find Out More",
  //   path: "/about",
  // },
  // {
  //   name: "The Experience",
  //   path: "/process",
  // },
  // {
  //   name: "Contact Info",
  //   path: "/contact",
  // },
  // {
  //   name: "NotFound",
  //   path: "/notFound",
  // },
];

export const testimonials = [
  // Image should be a square with the person's nose in the center
  // fileName = "avatar-firstInitialLastname.jpg"
  {
    id: 1,
    name: "Fake Persona Woman",
    quote:
      "I cannot express enough how grateful my husband and I are to have had Gabriela as the officiant for our wedding ceremony. From the moment we met, she exuded warmth and professionalism, making us feel instantly at ease during such a nerve-wracking time. She took the time to truly get to know us as a couple, and it was evident in the personalized ceremony she crafted for us. Her words were heartfelt, eloquent, and perfectly captured the essence of our relationship. Throughout the planning process, she was incredibly responsive and accommodating, always going above and beyond to ensure our day was everything we dreamed of. Our guests are still raving about how beautiful and meaningful the ceremony was, and we owe it all to Gabriela. I wholeheartedly recommend her to anyone looking for a celebrant who will make their special day truly unforgettable.",
    relationship: "ChatGPT Creation",
    avatar: require("./images/avatar-FPWoman.jpg"),
  },
  {
    id: 2,
    name: "Geoffery Gibbons",
    quote:
      "Working with Gabriela while constructing this website could not have been more enjoyable. Her easy-going and relaxed style of getting things done made every step along the way feel like playing a game rather than working. I'm confident she will bring the same unique, infectiously happy, peaceful, and determined energy to any of the ceremonies and celebrations she's involved in.",
    relationship: "Website Manager",
    avatar: require("./images/avatar-ggibbons.jpg"),
  },
  {
    id: 3,
    name: "Fake Persona Man",
    quote:
      "I can't express enough how grateful my wife and I are to have had Gabriela officiate our vow renewal ceremony. From the moment we first spoke, she showed genuine interest in our story and what we hoped to convey through our ceremony. She took the time to understand the significance of our renewal and worked closely with us to create a ceremony that was deeply personal and meaningful. Gabriela has a remarkable gift for crafting words that touch the heart, and she delivered a ceremony that left not a dry eye in the house. Her calming presence and genuine warmth helped to set the perfect tone for the day, and we couldn't have asked for a more perfect celebration of our love and commitment. Our friends and family are still talking about how moving and memorable the ceremony was, and it's all thanks to Gabriela. If you're looking for someone to help you celebrate life's milestones with sincerity and grace, she is the one to call. Thank you, Gabriela, for making our vow renewal so incredibly special.",
    relationship: "ChatGPT Creation",
    avatar: require("./images/avatar-FPMan.jpg"),
  },
];

export const faqs = [
  {
    id: 1,
    question: "• How much do you charge?",
    answer:
      "Pricing will vary depending on a number of factors but if your ceremony is in the Whistler area my standard rate is $600.00 CAD.",
  },
  {
    id: 2,
    question: "• In what area(s) do you perform ceremonies?",
    answer:
      "Whistler has been my home for more than 20 years and is the area I typically perform ceremonies in, but I'm willing to travel anywhere in the Coastal Mountain Region or Vancouver Island if need be. If you have a special or adventurously remote destination in mind for your ceremony please don't hesitate to get in touch and see if I can get there for you. There's no valley too deep or mountain too high...",
  },
  {
    id: 3,
    question: "• Will you help us plan out a ceremony we'll never forget?",
    answer:
      "Of Course! There's nothing I'd rather do more. Each ceremony I put together is unique and meant to be both eactly what you need for the occassion, and something eveyone whom participates finds unforgettable. We won't move forward until you're not just satisfied but excited to experience the ceremony we create together.",
  },
  {
    id: 4,
    question: "• Will you help us plan out our wedding?",
    answer:
      "No silly! That's what Wedding Planners are for, and I think they're generally vital to having such an important event go off without a hitch. I regularly work with many amazing planners and always enjoy meeting new ones. I'll work hand-in-hand with your planner to help create a beautiful day but ceremonies are where my specialties lie, I leave full event planning up to the experts.",
  },
  {
    id: 5,
    question: "• Can we use our own wording for our vows?",
    answer:
      "Not only can you but I whole-heartedly encourage it. And if you'd like a little assistance in the wording department I will help with that too. The details of the vow exchange are something we'll go over thoroughly, both wording and timing, as we create your ceremony together, should you choose to move forward with myself as your celebrant.",
  },
  {
    id: 6,
    question:
      "• Gabi-chu I choose you! *throws pokeball* Ok, you're in, what's next?",
    answer:
      "Next, you hit the button right here --> and we set up your complementary consutation. We have a talk about what you'll need from me, what I'll need from you, get a feel for what it will be like creating with each other and save the date. I can't wiat to hear from you!",
  },
];

export const steps = [
  {
    id: 1,
    icon: <PiStairsFill />,
    title: "Step One",
    desc: "We arrange a time for your complimentary consultation, making sure we're the right 'fit' for each other and that I'm available on your special day.",
  },
  {
    id: 2,
    icon: <PiStairsFill />,
    title: "Step Two",
    desc: "We come to an agreement regarding what I'm going to provide to you as your celebrant, what I need from you as my revellers, and how much my services will cost.",
  },
  {
    id: 3,
    icon: <PiStairsFill />,
    title: "Step Three",
    desc: "I save your dates in my schedule for up to seven business days, allowing you time to make a final decision on whether or not we move forward",
  },
  {
    id: 4,
    icon: <PiStairsFill />,
    title: "Step Four",
    desc: "If your decision is a 'Yes, let's book it!' I provide an additional 7 days for you to return my signed contract and arrange payment details with me.",
  },
  {
    id: 5,
    icon: <PiStairsFill />,
    title: "Step Five",
    desc: "We plan an experience no one is soon to forget and we celebrate!",
  },
];

export const packages = [
  {
    id: 1,
    name: "A Local Celebration",
    desc: "You want an amazing ceremony. I create amazing ceremonies!",
    features: [
      { feature: "First Feature", included: true },
      { feature: "Second Feature", included: true },
      { feature: "Third Feature", included: true },
      { feature: "Fourth Feature", included: true },
      { feature: "Fifth Feature", included: true },
      { feature: "Fifth Feature Plus", included: false },
      { feature: "Sixth Feature", included: false },
      { feature: "Seventh Feature", included: false },
      { feature: "Seventh Feature Plus", included: false },
      { feature: "Eighth Feature", included: false },
      { feature: "Ninth Feature", included: false },
      { feature: "Tenth Feature", included: false },
      { feature: "Eleventh Feature", included: false },
    ],
    price: 597.99,
  },
  {
    id: 2,
    name: "A Bare-Bones Elopement",
    desc: "The Quick'n'Dirty, Get'er done Experience",
    features: [
      { feature: "First Feature", included: true },
      { feature: "Second Feature", included: true },
      { feature: "Third Feature", included: true },
      { feature: "Fourth Feature", included: true },
      { feature: "Fifth Feature", included: true },
      { feature: "Fifth Feature Plus", included: true },
      { feature: "Sixth Feature", included: true },
      { feature: "Seventh Feature", included: true },
      { feature: "Seventh Feature Plus", included: true },
      { feature: "Eighth Feature", included: false },
      { feature: "Ninth Feature", included: false },
      { feature: "Tenth Feature", included: false },
      { feature: "Eleventh Feature", included: false },
    ],
    price: 397.99,
  },
  {
    id: 3,
    name: " A Witness or Simple Signing",
    desc: "If all you need is a certified celebrant there to make things official, I can help with that too!",
    features: [
      { feature: "First Feature", included: true },
      { feature: "Second Feature", included: true },
      { feature: "Third Feature", included: true },
      { feature: "Fourth Feature", included: true },
      { feature: "Fifth Feature", included: true },
      { feature: "Fifth Feature Plus", included: true },
      { feature: "Sixth Feature", included: true },
      { feature: "Seventh Feature", included: true },
      { feature: "Seventh Feature Plus", included: true },
      { feature: "Eighth Feature", included: true },
      { feature: "Ninth Feature", included: true },
      { feature: "Tenth Feature", included: true },
      { feature: "Eleventh Feature", included: true },
    ],
    price: 97.99,
  },
  {
    id: 4,
    name: "A Destination Celebration",
    desc: "Celebrating Somewhere REALLY Special? Bring me along!",
    features: [
      { feature: "First Feature", included: true },
      { feature: "Second Feature", included: true },
      { feature: "Third Feature", included: true },
      { feature: "Fourth Feature", included: true },
      { feature: "Fifth Feature", included: true },
      { feature: "Fifth Feature Plus", included: true },
      { feature: "Sixth Feature", included: true },
      { feature: "Seventh Feature", included: true },
      { feature: "Seventh Feature Plus", included: true },
      { feature: "Eighth Feature", included: true },
      { feature: "Ninth Feature", included: true },
      { feature: "Tenth Feature", included: true },
      { feature: "Eleventh Feature", included: true },
    ],
    price: " Consultation Required",
  },
];
